import { createContext, useContext, useEffect, useState } from 'react'
import { getItem, setItem } from '../utils/storage'

const SoundContext = createContext()

export function SoundProvider ({ children }) {
  const [soundEnabled, setSoundEnabled] = useState(() => {
    const stored = getItem('soundEnabled')
    return stored !== null ? stored === 'true' : true
  })

  useEffect(() => {
    setItem('soundEnabled', soundEnabled)
  }, [soundEnabled])

  const toggleSound = () => {
    setSoundEnabled(prev => !prev)
  }

  return (
    <SoundContext.Provider value={{ soundEnabled, toggleSound }}>
      {children}
    </SoundContext.Provider>
  )
}

export function useSound () {
  const context = useContext(SoundContext)
  if (!context) {
    throw new Error('useSound must be used within a SoundProvider')
  }
  return context
}
